import * as React from 'react';

class AuthError extends React.Component<any> {

  signIn = () => {
    this.props.auth.login()
  }
  render() {
    return (

      <section role="form-section">
        <div className="auth-error-wrap">
          <div className="auth-error-icon"><img src="images/letter.svg" /></div>
          <h2>Time to Check Your Email</h2>
          <p> Your email has not been confirmed yet. Please confirm your email.</p>
          {/* <button  onClick={this.signIn} className="btn btn-md btn-blue">Login</button> */}
        </div>
      </section>

    );
  }
}

export default AuthError;
